module.exports = __webpack_public_path__ + "media/images/flags/16/Democratic-Republic-of-the-Congo-debf4a569e9cee9adb609e3e96d8c56e.png";